import { OptionalMark } from "./components/FormDisplayContext";
import { useFormContext } from "react-hook-form";
import { FileInput as UIFileInput, type FileInputProps as UIFileInputProps } from "@patient-watch/ui/file-input";
import { FormControl, FormDescription, FormField, FormItem, FormMessage } from "@patient-watch/ui/form";
import { Label } from "@patient-watch/ui/label";
import { RichLabel } from "./components/RichLabel";

interface FileInputProps extends Omit<UIFileInputProps, "value" | "onChange"> {
    name: string;
    label?: string;
    description?: string;
    required?: boolean;
}

const FileInput = ({ name, label, description, required = false, ...fileInputProps }: FileInputProps) => {
    const { control } = useFormContext();

    return (
        <FormField
            control={control}
            name={name}
            render={({ field }) => (
                <FormItem>
                    {label ? (
                        <Label>
                            <RichLabel>{label}</RichLabel>
                            {!required ? <OptionalMark /> : null}
                        </Label>
                    ) : null}
                    <FormControl>
                        <UIFileInput
                            {...fileInputProps}
                            value={(field.value as File | null | undefined) ?? null}
                            onChange={field.onChange}
                        />
                    </FormControl>
                    {description ? <FormDescription>{description}</FormDescription> : null}
                    <FormMessage />
                </FormItem>
            )}
        />
    );
};

export default FileInput;
